import { render, staticRenderFns } from "./AdmissionForm.vue?vue&type=template&id=d2da4e14"
import script from "./AdmissionForm.vue?vue&type=script&lang=js"
export * from "./AdmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports